import React from "react";

import { DropDownItem } from "../UIElements";
import DropDown from "../UIElements/DropDown";

interface SelectProps {
    defaultValue?: DropDownItem;
    options: DropDownItem[];
    onSelect: (selectedValue: number) => void;
}

const AccountSwitcherForm: React.FC<SelectProps> = ({
    options,
    onSelect,
    defaultValue,
}) => {
    const handleSelect = (selectedValue: any) => {
        onSelect(selectedValue.target.value);
    };
    return (
        <DropDown
            items={options}
            inputlabel="Changer de compte"
            onChange={handleSelect}
            defaultValue={defaultValue ? defaultValue.id : ""}
            selectpx={{
                border: "2px solid  #E3E6E8",
                background: "#FFF",
            }}
            root={{
                width: "100%",
                "@media (max-width:1024px)": {
                    width: "100%",
                },
            }}
        />
    );
};

export default AccountSwitcherForm;
